import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {
  fndDataSelector,
  ambienceRatingSelector,
  tasteRatingSelector,
  foodDiningAltAccoDataSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {FoodDiningShape} from '@stencil/hotels-cg-reducer/src/details/types';

import SingleRestaurentUI from '../../../../../stories/components/hotels/DetailsPageUnif/FoodWidget/SingleRestaurentUI/SingleRestaurentUI';
import MultiRestaurentUI from '../../../../../stories/components/hotels/DetailsPageUnif/FoodWidget/MultiRestaurentUI/MultiRestaurentUI';
import PropertyRules from '../../../../../stories/components/hotels/DetailsPageUnif/FoodWidget/PropertyRules/PropertyRules';
import DiningUI from '../../../../../stories/components/hotels/DetailsPageUnif/FoodWidget/DiningUI/DiningUI';

export default function FoodWidget() {
  const fnd = useSelector(fndDataSelector);
  const ambienceRating = useSelector(ambienceRatingSelector);
  const tasteRating = useSelector(tasteRatingSelector);
  const altAccofndData = useSelector(foodDiningAltAccoDataSelector);

  const {restaurants, hasRestaurant, hasRoomDining, propertyRules} = fnd || {};

  const hasFndData = fnd && Object.keys(fnd).length !== 0;
  const hasSpaceData = restaurants?.length > 0;
  const isMultiRestraunt = restaurants?.length > 1;

  const hasFndAllowedRules = propertyRules?.allowed?.length > 0;
  const hasFndNotAllowedRules = propertyRules?.notAllowed?.length > 0;

  const haveAtleastOnePropertyRule = hasFndAllowedRules || hasFndNotAllowedRules;

  const hasAltAccoFndData = !!altAccofndData?.allRules?.length || !!altAccofndData?.summary?.length;

  if (hasAltAccoFndData) {
    return (
      <DiningUI
        header={altAccofndData?.title}
        data={altAccofndData?.summary}
        allRules={altAccofndData?.allRules}
      />
    );
  }

  if (!hasFndData || (!hasRestaurant && !hasRoomDining)) {
    return null;
  }

  return (
    <>
      {isMultiRestraunt ? (
        <MultiRestaurentUI
          fnd={fnd as FoodDiningShape}
          ambienceRating={ambienceRating}
          tasteRating={tasteRating}
        />
      ) : (
        <SingleRestaurentUI
          fnd={fnd as FoodDiningShape}
          hasKitchen={!!hasRoomDining}
          ambienceRating={ambienceRating}
          tasteRating={tasteRating}
        />
      )}
      {haveAtleastOnePropertyRule && (
        <PropertyRules
          heading="Property Rules"
          propertyRules={propertyRules}
          hasFndAllowedRules={hasFndAllowedRules}
          hasFndNotAllowedRules={hasFndNotAllowedRules}
        />
      )}
    </>
  );
}
